import { INITIAL_WEBSITE_TYPE } from "pro-features/components/filtersPanel/src/WebsiteTypeFilter";
import type { ISortDirection } from "app/components/React/Table/Utils/sort";
import type { ISortableColumns, IRawData, IFilters } from "./types";

export const INITIAL_RAW_DATA_STATE: IRawData = {
    TotalCount: Number(),
    Data: [],
};

export const RANGE = {
    UNIQUE_USERS: { min: 0, max: 10_000_000 },
    MONTHLY_VISITS: { min: 0, max: 500_000_000 },
};

const { MONTHLY_VISITS, UNIQUE_USERS } = RANGE;

export const INITIAL_TRAFFIC = {
    monthlyVisits: { from: MONTHLY_VISITS.min, to: MONTHLY_VISITS.max },
    uniqueUsers: { from: UNIQUE_USERS.min, to: UNIQUE_USERS.max },
    isUniqueToggle: false,
};

const DEFAULT_SORT_FIELD = "Share" as ISortableColumns;
const DEFAULT_SORT_DIRECTION = "desc" as ISortDirection;

const INITIAL_ORDER_BY = {
    field: DEFAULT_SORT_FIELD,
    sortDirection: DEFAULT_SORT_DIRECTION,
};

export const INITIAL_FILTERS: IFilters = {
    websiteType: INITIAL_WEBSITE_TYPE,
    traffic: INITIAL_TRAFFIC,
    orderBy: INITIAL_ORDER_BY,
    page: 1,
};
